import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Card, CardBody, Button, FormGroup, Input, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, dateFilter, numberFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
const { ExportCSVButton } = CSVExport;

import TicketsEditor from '../Tickets/Editor';

import Lang from '../../languages';
import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

class ProductsEvents extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   totalSize: 0,
   sizePerPage: 10,
   sortOrder: 'asc',
   sortField: 'start_date',
   editorWindow: false,
   selected: [],
   selectedEvent: null,
   finished: false,
   disabled: false
  };

  this.filters = { 'text': {}, 'number': {}, 'date': {} }

  if (window.innerWidth <= 768) {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Products.columns.name, formatter: (cellContent, row) => { return <Link to={'/products/' + row.productID}>{cellContent}</Link> }, sort: true }
   ]
  } else {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Products.columns.name, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: textFilter({ getFilter: (filter) => { this.filters['text'].name = filter } }), headerStyle: () => { return { width: '35%' } }, formatter: (cellContent, row) => { return <Link to={'/products/' + row.productID}>{cellContent}</Link> }, sort: true },
    { dataField: 'establishmentName', text: Lang[this.props.session.language].Products.columns.establishment, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: textFilter({ getFilter: (filter) => { this.filters['text'].establishmentName = filter } }), formatter: (cellContent, row) => { return <Link to={'/establishments/' + row.establishment}>{cellContent}</Link> }, sort: true },
    { dataField: 'type', text: Lang[this.props.session.language].Products.columns.type, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: textFilter({ getFilter: (filter) => { this.filters['text'].type = filter } }), formatter: cell => cell, sort: true },
    { dataField: 'start_date', text: Lang[this.props.session.language].Products.columns.start_date, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].start_date = filter } }), formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].datetimeFormat); }, sort: true },
    { dataField: 'finish_date', text: Lang[this.props.session.language].Products.columns.finish_date, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].finish_date = filter } }), formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].datetimeFormat); }, sort: true },
    { dataField: 'bookings', text: Lang[this.props.session.language].Products.columns.bookings, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}}, filter: numberFilter({ getFilter: (filter) => { this.filters['number'].bookings = filter } }), headerStyle: () => { return { width: '150px' } }, formatter: cell => cell, sort: true },
    {
     dataField: 'ID', text: 'ID', headerStyle: () => { return { width: '60px' } }, headerFormatter: () => (
      <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i></Button>
     ), formatExtraData: this.state.data, style: (cell, row) => { return row.status > 0? {}:{ backgroundColor:'rgb(238 145 145 / 50%)'}},
     formatter: (cell, row, rowIndex, extraData) => {
      return (
       <div className="checkbox disabled">
        {
         parseInt(this.state.data[rowIndex].status) > 0 ?
          this.props.session.permissions.controllers.tickets.find(el => el == 'create') ?
           <Button color="success" onClick={() => this.openEditor(row.ID)}><i className="fa fa-ticket"></i></Button>
           : null
          : null
        }
        {' '}
        {
         parseInt(this.state.data[rowIndex].status) > 0 ?
          (this.props.session.user.ID == row.owner && row.bookings == 0) ?
           <Button color="secondary" onClick={() => this.doDisable(row.ID)}><i className="fa fa-pause"></i></Button>
           : null
          : this.props.session.user.ID == row.owner ?
           <Button color="secondary" onClick={() => this.doEnable(row.ID)}><i className="fa fa-play"></i></Button>
           : null
        }
       </div>
      )
     }
    }
   ]
  }

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);
  this.resetFilters = this.resetFilters.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.forceTableChange = this.forceTableChange.bind(this);

  this.doEnable = this.doEnable.bind(this);
  this.doDisable = this.doDisable.bind(this);
 }

 resetFilters() {
  Object.keys(this.filters).forEach(type => {
   Object.keys(this.filters[type]).forEach(key => {
    var filterFunction = this.filters[type][key];
    switch (type) {
     case 'text': filterFunction(''); break;
     case 'date': filterFunction({ date: new Date(), comparator: '' }); break;
     case 'number': filterFunction({ number: '', comparator: '' }); break;
    }
   });
  })
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder }) {
  this.props.reqAPI(Config.apiURI + '/api/products/events', 'POST', { page, sizePerPage, filters, sortField, sortOrder, language: this.props.session.language, finished: this.state.finished, disabled: this.state.disabled }).then(data => {
   this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
  });
 }

 forceTableChange() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 openEditor(ID) {
  if (ID === null) {
   this.setState({ selectedEvent: null }, function () {
    this.setState({ editorWindow: true });
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/products/events/' + ID + '?full').then(event => {
    this.setState({ selectedEvent: event }, function () {
     this.setState({ editorWindow: true });
    });
   })
  }
 }

 closeEditor(state) {
  if (state) toast.success('Los cambios han sido guardados');
  this.setState({ selectedEvent: null, editorWindow: false }, this.forceTableChange);
 }

 doDisable(ID) {
  this.props.reqAPI(Config.apiURI + '/api/products/events/' + ID, 'DELETE').then(result => {
   var lastState = this.state;
   lastState.data.map((item, key) => { if(item.ID === ID) lastState.data[key].status = '-1' })
   this.props.reload(lastState);
  }).catch((error) => {
   console.error(error);
  });
 }

 doEnable(ID) {
  this.props.reqAPI(Config.apiURI + '/api/products/events/' + ID, 'PUT').then(result => {
   var lastState = this.state;
   lastState.data.map((item, key) => { if(item.ID === ID) lastState.data[key].status = '1' })
   this.props.reload(lastState);
  }).catch((error) => {
   console.error(error);
  });
 }

 componentDidMount() {
  if(this.props.lastState) {
   this.setState(this.props.lastState, () => this.forceTableChange())
  } else {
   this.forceTableChange();
  }
 }


 render() {
  return (
   <Card>
    <ToolkitProvider keyField="ID" data={this.state.data} columns={this.columns} exportCSV>
     {
      props => (
       <CardBody>
        <ExportCSVButton className="btn btn-primary" {...props.csvProps}>{Lang[this.props.session.language].ExportCSV}</ExportCSVButton>
        <FormGroup className="float-right" check inline>
         <Input type="checkbox" checked={this.state.finished} onChange={(e) => { this.setState({ finished: e.target.checked }, this.forceTableChange) }} />
         <Label check>{Lang[this.props.session.language].Products.buttons.showFinished}</Label>
        </FormGroup>
        <FormGroup className="float-right" check inline>
         <Input type="checkbox" checked={this.state.disabled} onChange={(e) => { this.setState({ disabled: e.target.checked }, this.forceTableChange) }} />
         <Label check>{Lang[this.props.session.language].Products.buttons.showDisabled}</Label>
        </FormGroup>
        <BootstrapTable
         remote
         striped
         condensed
         bootstrap4
         keyField="ID"
         bordered={false}
         data={this.state.data}
         columns={this.columns}
         defaultSorted={[{
          dataField: 'start_date',
          order: 'asc'
         }]}
         filter={filterFactory()}
         pagination={
          paginationFactory({
           page: this.state.page,
           sizePerPage: this.state.sizePerPage,
           sizePerPageList: [
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '100', value: 100 }
           ],
           showTotal: true,
           totalSize: this.state.totalSize,
           firstPageText: Lang[this.props.session.language].pagination.firstPageText,
           prePageText: Lang[this.props.session.language].pagination.prePageText,
           nextPageText: Lang[this.props.session.language].pagination.nextPageText,
           lastPageText: Lang[this.props.session.language].pagination.lastPageText,
           firstPageTitle: Lang[this.props.session.language].pagination.firstPageTitle,
           nextPageTitle: Lang[this.props.session.language].pagination.nextPageTitle,
           prePageTitle: Lang[this.props.session.language].pagination.prePageTitle,
           lastPageTitle: Lang[this.props.session.language].pagination.lastPageTitle,
           paginationTotalRenderer: (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total" dangerouslySetInnerHTML={{ __html: '&nbsp;' + Lang[this.props.session.language].paginationFooter(from, to, size) + ' ' + Lang[this.props.session.language].Events.name }} />
           )
          })
         }
         onTableChange={this.handleTableChange}
         noDataIndication={Lang[this.props.session.language].tableEmpty}
         {...props.baseProps} />
       </CardBody>
      )
     }
    </ToolkitProvider>

    <TicketsEditor {...this.props} open={this.state.editorWindow} event={this.state.selectedEvent} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default ProductsEvents;



// WEBPACK FOOTER //
// ./websources/views/Products/Events.js